<template>
  <v-container fluid class="price-and-compare-details" pa-0>

    <v-row no-gutters class="pt-3" :class="{'pl-3': $vuetify.breakpoint.xsOnly}">
      <h3 class="font-weight-black text-uppercase">Käyttöönottokustannukset</h3>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" md="4" class="pe-green lighten" :class="$vuetify.breakpoint.xsOnly ? 'pa-3' : 'pa-5'">
        <h4>Kaukolämpö</h4>
        <div class="result-text big-text">{{ round(prices.kaukolampo.kayttoonottokustannukset) }} €</div>
      </v-col>
      <v-col cols="12" md="8">
        <compare-detail-fields :prices="prices" field="kayttoonottokustannukset" unit="€" />
      </v-col>
    </v-row>

    <v-row no-gutters class="pt-3" :class="{'pl-3': $vuetify.breakpoint.xsOnly}">
      <h3 class="font-weight-black text-uppercase">Käyttökustannukset vuodessa</h3>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" md="4" class="pe-green lighten" :class="$vuetify.breakpoint.xsOnly ? 'pa-3' : 'pa-5'">
        <h4>Kaukolämpö</h4>
        <div class="result-text big-text">{{ round(prices.kaukolampo.kayttokustannukset_vuodessa) }} €</div>
      </v-col>
      <v-col cols="12" md="8">
        <compare-detail-fields :prices="prices" field="kayttokustannukset_vuodessa" unit="€" />
      </v-col>
    </v-row>

    <v-row no-gutters class="pt-3" :class="{'pl-3': $vuetify.breakpoint.xsOnly}">
      <h3 class="font-weight-black text-uppercase">Energiankulutus vuodessa</h3>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" md="4" class="pe-green lighten" :class="$vuetify.breakpoint.xsOnly ? 'pa-3' : 'pa-5'">
        <h4>Kaukolämpö</h4>
        <div class="result-text big-text">{{ round(prices.kaukolampo.energiakulutus_vuodessa) }} MWh</div>
      </v-col>
      <v-col cols="12" md="8">
        <compare-detail-fields :prices="prices" field="energiakulutus_vuodessa" unit="MWh" />
      </v-col>
    </v-row>

    <v-row no-gutters class="pt-3" :class="{'pl-3': $vuetify.breakpoint.xsOnly}">
      <h3 class="font-weight-black text-uppercase">Hiilidioksidipäästöt vuodessa</h3>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" md="4" class="pe-green lighten" :class="$vuetify.breakpoint.xsOnly ? 'pa-3' : 'pa-5'">
        <h4>Kaukolämpö</h4>
        <div class="result-text big-text">{{ round(prices.kaukolampo.co2_vuodessa) }} kg</div>
        <div class="caption mt-5">*Hiilidioksipäästöt on mahdollista kompensoida nollaan erilaisilla sopimustyypeillä, esim. Täysvihreätakuu kaukolämmöllä.</div>
      </v-col>
      <v-col cols="12" md="8">
        <compare-detail-fields :prices="prices" field="co2_vuodessa" unit="kg" />
      </v-col>
    </v-row>

    <v-row no-gutters class="pt-3" :class="{'pl-3': $vuetify.breakpoint.xsOnly}">
      <h3 class="font-weight-black text-uppercase">Pääomakustannukset vuodessa</h3>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" md="4" class="pe-green lighten" :class="$vuetify.breakpoint.xsOnly ? 'pa-3' : 'pa-5'">
        <h4>Kaukolämpö</h4>
        <div class="result-text big-text">{{ round(prices.kaukolampo.paaomakustannukset_vuodessa)}} €</div>
      </v-col>
      <v-col cols="12" md="8">
        <compare-detail-fields :prices="prices" field="paaomakustannukset_vuodessa" unit="€" />
      </v-col>
    </v-row>

    <v-row no-gutters class="pt-3" :class="{'pl-3': $vuetify.breakpoint.xsOnly}">
      <h3 class="font-weight-black text-uppercase">Energian kokonaiskustannukset €/MWh</h3>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" md="4" class="pe-green lighten" :class="$vuetify.breakpoint.xsOnly ? 'pa-3' : 'pa-5'">
        <h4>Kaukolämpö</h4>
        <div class="result-text big-text">{{ round(prices.kaukolampo.energia_kokonaiskustannukset_mwh) }} €/MWh </div>
      </v-col>
      <v-col cols="12" md="8">
        <compare-detail-fields :prices="prices" field="energia_kokonaiskustannukset_mwh" unit="€/MWh"  />
      </v-col>
    </v-row>

    <v-row no-gutters class="pt-3" :class="{'pl-3': $vuetify.breakpoint.xsOnly}">
      <h4 class="font-weight-black text-uppercase">Kustannukset käyttöiälle</h4>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" md="4" class="pe-green lighten" :class="$vuetify.breakpoint.xsOnly ? 'pa-3' : 'pa-5'">
        <h3>Kaukolämpö</h3>
        <div class="result-text big-text">{{ round(prices.kaukolampo.kustannukset_kayttoialle )}} €</div>
      </v-col>
      <v-col cols="12" md="8">
        <compare-detail-fields :prices="prices" field="kustannukset_kayttoialle" unit="€" />
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" class="pe-green pa-5">
        <v-row align="center" justify="center">
          <button type="button" @click="openOfferRequestForm" title="Pyydä tarjous kaukolämmöstä"  class="main-btn">Pyydä tarjous kaukolämmöstä <v-icon style="margin-top: -4px;" size="26">mdi-arrow-right</v-icon></button>
        </v-row>
      </v-col>
    </v-row>

    <v-row row wrap no-gutters class="pb-5">
      <v-col cols="12" md="6" class="pt-3">
        <v-btn color="grey lighten-4" elevation="0" style="text-transform: none;" @click="goBack" :block="$vuetify.breakpoint.xsOnly" :large="$vuetify.breakpoint.mdAndUp"><v-icon size="18" left>mdi-arrow-left</v-icon>Palaa yksinkertaisempaan näkymään</v-btn>
      </v-col>
      <v-col cols="12" md="6" class="pt-3 pb-5 text-md-right">
        <v-btn color="grey lighten-4" elevation="0" style="text-transform: none;" @click="openCalculationFormulas" :block="$vuetify.breakpoint.xsOnly" :large="$vuetify.breakpoint.mdAndUp">
          <v-icon v-if="$vuetify.breakpoint.xsOnly" size="18" left>mdi-information</v-icon>
          Laskennassa käytetyt tiedot
          <v-icon v-if="$vuetify.breakpoint.smAndUp" size="18" right>mdi-information</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <calculations-explained-dialog ref="calculationsExplainedDialog" />
  </v-container>
</template>

<script>
  import CompareDetailFields from "./CompareDetailFields";
  import CalculationsExplainedDialog from "./CalculationsExplainedDialog";
  import { round } from "mathjs";

  export default {
    name: "PriceAndCompareDetails",
    props: {
      propertyInformation: {
        type: Object,
        default: null,
      },
    },
    components: {
      CompareDetailFields,
      CalculationsExplainedDialog,
    },
    computed: {
      prices() {
        return this.propertyInformation.prices;
      },
    },
    methods: {
      round(value) {
        return round(value).toLocaleString('fi');
      },
      openOfferRequestForm() {
        this.$emit('open-offer-request-form', this.prices);
      },
      goBack() {
        this.$emit('go-back');
      },
      openCalculationFormulas() {
        this.$refs.calculationsExplainedDialog.open();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .result-text {
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    margin-top: 5px;

    .dark {
      font-size: 14px;
      color: rgba(0,0,0,0.45);
    }

    &.big-text {
      font-size: 31px;
    }
  }

  @media only screen and (min-width: 600px) {
    .result-text {
      font-size: 28px;

      .dark {
        font-size: 22px;
        line-height: 22px;
      }

      &.big-text {
        font-size: 42px;
      }
    }
  }
</style>
